// Map.tsx
import React, {useState} from 'react';
import "./Map.scss";
import { GoogleMap, MarkerF, OverlayViewF, InfoWindowF } from '@react-google-maps/api';


interface MapProps {
  lat: number;
  lng: number;
  zoom?: number;
  label: string;
}

const containerStyle: React.CSSProperties = {
  width: '100%',
  maxWidth: '1650px',
  height: '525px',
  margin: '0 auto',
};

/* const color = '#0C1E31'; // Dark blue color for the vineyard marker
const strokeWidth = 2;
const svg = `
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
    <!-- main pin shape -->
    <path
      d="M16 0C9.3726 0 4 5.3726 4 12c0 8 12 20 12 20s12-12 12-20c0-6.6274-5.3726-12-12-12z"
      fill="${color}"
      stroke="#ffffff"
      stroke-width="${strokeWidth}"
      stroke-linejoin="round"
    />
    <!-- white center dot -->
    <circle
      cx="16" 
      cy="12" 
      r="4" 
      fill="#ffffff"
    />
  </svg>
`;
const svgUrl = `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
*/


export function VineyardMap({ lat, lng, zoom = 15, label = "" }: MapProps) {
  const center = { lat, lng };
  const [infoOpen, setInfoOpen] = useState(false)
  const mapUrl = `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`

  return (
    <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={zoom}
        options={{
            mapTypeId: 'hybrid',
            zoomControl: true,
            styles: [
                {
                  featureType: 'administrative.locality',
                  elementType: 'labels',
                  stylers: [{ visibility: 'on' }]
                },
                {
                  featureType: 'poi',
                  elementType: 'labels',
                  stylers: [{ visibility: 'on' }]
                },
                {
                  featureType: 'poi.medical',
                  elementType: 'labels',
                  stylers: [{ visibility: 'off' }]
                },
                {
                  featureType: 'poi.business',
                  elementType: 'labels',
                  stylers: [{ visibility: 'off' }]
                },
                // …add more rules if you’d hidden them elsewhere
              ],
            streetViewControl: false,
            mapTypeControl: false,
            fullscreenControl: false,
        }}
        
      >
        <MarkerF 
          position={center}
          onClick={() => setInfoOpen(true)}
        />
        {infoOpen && (
          <InfoWindowF
            position={{ lat, lng }}
            onCloseClick={() => setInfoOpen(false)}
          ><div style={{ fontSize: '12px' }}>
                <div style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '5px' }}>
                  {label}
                </div>
                <a
                  href={mapUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >View on google maps</a>
              </div>
          </InfoWindowF>
        )}

        {/* 2) Your HTML label, fully styleable with CSS */}
        <OverlayViewF
          position={{ lat, lng }}
          mapPaneName="overlayMouseTarget"
        >
          <div className="vineyard-label">
            {label}
          </div>
        </OverlayViewF>
      </GoogleMap>
  );
}
